module.exports = __webpack_public_path__ + "static/media/6590aac8-6bbf-4ca5-9a42-d58b709895cb_1.7cb5da2f4f038d417f2f6535f4bd1f43.a92659e8.jpeg";